import React from 'react';
import { useState, useEffect } from 'react';
import { BiFile as FileIcon } from 'react-icons/bi';
import { FiUser as UserIcon } from 'react-icons/fi';
import { MdCreditCard as CardIcon } from 'react-icons/md';
import { BsGear as GearIcon } from 'react-icons/bs';
import { FaBuilding as WorkspaceIcon } from 'react-icons/fa';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { routesPath } from '@constants/routesPath';

export const PipelineNav = () => {
  const navigate = useNavigate();
  const [activeTabIndex, setActiveIndex] = useState(1);
  const location = useLocation();
  useEffect(() => {
    // if(activeTabIndex==1){
    //   navigate('/settings/pipelines')
    // }else{
    //   navigate('/settings')
    // };
    if (location.pathname == routesPath.RolesAndPermissions) {
      setActiveIndex(2);
    } else if (location.pathname == routesPath.pipelineList()) {
      setActiveIndex(1);
    } else if (location.pathname == routesPath.billing) {
      setActiveIndex(3);
    } else if (location.pathname == routesPath.JobsEmbed) {
      setActiveIndex(4);
    } else if (location.pathname == routesPath.integration) {
      setActiveIndex(5);
    } else if (location.pathname == routesPath.workspaces) {
      setActiveIndex(6);
    }
  }, [location.pathname]);

  return (
    <>
      <ul>
        <li
          onClick={() => {
            navigate(routesPath.pipelineList());
            setActiveIndex(1);
          }}
          className={activeTabIndex == 1 ? 'active' : ''}
        >
          <FileIcon size={18} />
          Pipeline templates
        </li>
        <li
          onClick={() => {
            navigate(routesPath.RolesAndPermissions);
            setActiveIndex(2);
          }}
          className={activeTabIndex == 2 ? 'active' : ''}
        >
          <UserIcon size={18} />
          Roles and permissions
        </li>
        <li
          onClick={() => {
            navigate(routesPath.billing);
            setActiveIndex(3);
          }}
          className={activeTabIndex == 3 ? 'active' : ''}
        >
          <CardIcon size={18} />
          Billing and account details
        </li>
        <li
          onClick={() => {
            navigate(routesPath.JobsEmbed);
            setActiveIndex(4);
          }}
          className={activeTabIndex == 4 ? 'active' : ''}
        >
          <CardIcon size={18} />
          Jobs Embed
        </li>
        <li
          onClick={() => {
            navigate(routesPath.integration);
            setActiveIndex(5);
          }}
          className={activeTabIndex == 5 ? 'active' : ''}
        >
          <GearIcon size={18} />
          Integrations
        </li>
        <li
          onClick={() => {
            navigate(routesPath.workspaces);
            setActiveIndex(6);
          }}
          className={activeTabIndex == 6 ? 'active' : ''}
        >
          <WorkspaceIcon size={18} />
          Workspaces
        </li>
      </ul>
    </>
  );
};
